import React from "react";
import logo from "../assets/logo2.png";
import { Flex, Image } from "@chakra-ui/react";

const Navbar = () => {
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      bg="brand.900"
      w="100%"
      p={4}
      color="white"
    >
      <Image
        src={logo}
        w={["120px", "150px", "180px"]}
        h="auto"
        objectFit="contain"
      />{" "}
    </Flex>
  );
};

export default Navbar;
